import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const gLoaderCss = "@keyframes gloader{0%{transform:scale(0.8);opacity:0.3}10%{transform:scale(1);opacity:1}100%{transform:scale(0.8);opacity:0.3}}.g__loader{box-sizing:border-box;display:flex;justify-content:center}.g__loader--default .g__loader__dot{background-color:#6dcff6}.g__loader--dark .g__loader__dot{background-color:#000}.g__loader--light .g__loader__dot{background-color:#fff}.g__loader__dot{display:inline-block;flex:1 1 auto;padding-bottom:30%;margin-right:1%;margin-left:1%;animation:gloader 1.5s infinite cubic-bezier(0.165, 0.84, 0.44, 1);opacity:0.5;border-radius:100%}.g__loader__dot:nth-child(2){animation-delay:0.5s}.g__loader__dot:nth-child(3){animation-delay:1s}";
const GLoaderStyle0 = gLoaderCss;

const GLoader = /*@__PURE__*/ proxyCustomElement(class GLoader extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.type = 'default';
        this.styleObject = undefined;
        this.dataTestId = undefined;
    }
    render() {
        var _a;
        const baseClass = 'g__loader';
        const dotClass = `${baseClass}__dot`;
        const componentClasses = {
            [baseClass]: true,
            [`${baseClass}--${this.type}`]: Boolean(this.type),
        };
        return (h(Host, { key: '70ccc3ebf8badcbb4e70fd5739e961c407f1f45e', class: componentClasses, "data-testid": ((_a = this.dataTestId) === null || _a === void 0 ? void 0 : _a.host) || baseClass, style: this.styleObject || null }, h("i", { key: '218c44b30f5c4ae63a0ff12d0e4ae541f0c42dd8', class: dotClass }), h("i", { key: '3d9390141ba752b0f31bc0de6cdcb73393754c2c', class: dotClass }), h("i", { key: '6db648f688c911debf5e0d010ba3b0dfd8c53d5e', class: dotClass })));
    }
    static get style() { return GLoaderStyle0; }
}, [0, "g-loader", {
        "type": [513],
        "styleObject": [8, "style-object"],
        "dataTestId": [16]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["g-loader"];
    components.forEach(tagName => { switch (tagName) {
        case "g-loader":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, GLoader);
            }
            break;
    } });
}

export { GLoader as G, defineCustomElement as d };

//# sourceMappingURL=g-loader2.js.map